import React from 'react';

const AcceptableUse = () => {
 
    return (
       <div style={{padding: 18}}>
    <h2 align="center" style={{marginTop: 24, marginBottom: 24}}>
    <a name="_vljsfxwowan8"></a>
    <strong>Acceptable Use Policy</strong>
    <strong></strong>
</h2>
<p>
    Last Modified: October 6, 2021
</p>
<p>
    This Acceptable Use Policy (this “<strong>Policy</strong>”) shall govern
    your use of our Services. All terms used but not defined in this Policy
    shall have the meaning given to them in the Terms of Use.
</p>
<h3>
    <a name="_izm0faq9ws0u"></a>
    <strong>Prohibited Uses</strong>
</h3>
<p>
    You may use the Services only for lawful purposes and in accordance with
    these Terms of Use. You agree not to use the Services:

</p>
<p>
    ● In any way that violates any applicable federal, state, local or 
    international law or regulation (including, without limitation, any laws 
    regarding the export of data or software to and from the US or other countries).
</p>
<p>
    ● To send, knowingly receive, upload, download, use or re-use any material 
    which does not comply with the Content Standards set out in this Policy.
</p>
<p>
    ● To transmit, or procure the sending of, any advertising or promotional material, 
    including any “junk mail”, “chain letter” or “spam” or any other similar solicitation.
</p>
<p>
    ● To impersonate or attempt to impersonate the Understanding Ag, LLC(UA), a UA 
    employee, another user or any other person or entity (including, without limitation, 
    by using e-mail addresses associated with any of the foregoing).
</p>
<p>
    ● To engage in any other conduct that restricts or inhibits anyone’s use or enjoyment 
    of the Services, or which, as determined by us, may harm UA or users of the Services 
    or expose them to liability.
</p>
<p>
    Additionally, you agree not to:
</p>
<p>
    ● Use the Services in any manner that could disable, overburden, damage or impair the site 
    or interfere with any other party’s use of the Services, including their ability to engage 
    in real time activities through the Services.
</p>
<p>
    ● Use any robot, spider or other automatic device, process or means to access the Services 
    for any purpose, including monitoring or copying any of the material on the Services.
</p>
<p>
    ● Use any manual process to monitor or copy any of the material on the Services for any 
    other unauthorized purpose without our prior written consent.
</p>
<p>
    ● Use any device, software or routine that interferes with the proper working of the Services.
</p>
<p>
    ● Introduce any viruses, trojan horses, worms, logic bombs or other material which is malicious 
    or technologically harmful.
</p>
<p>
    ● Attempt to gain unauthorized access to, interfere with, damage or disrupt any parts of 
    the Services, a server on which the Services is stored, or any server, computer or 
    database connected to the Services.
</p>
<p>
    ● Attack the Services via a denial-of-service attack or a distributed denial-of-service attack.
</p>
<p>
    ● Otherwise attempt to interfere with the proper working of the Services.
</p>
<h3>
    <a name="_cus3a7lu8ba"></a>
    <strong>Content Standards</strong>
</h3>
<p>
    These content standards (the <b>“Content Standards”</b>) apply to 
    any and all User Contributions and use of Interactive Services. User 
    Contributions must in their entirety comply with all applicable federal, 
    state, local and international laws and regulations. In addition to the 
    foregoing, User Contributions must not:
</p>
<p>
    ● Contain any material which is defamatory, obscene, indecent, abusive, 
    offensive, harassing, violent, hateful, inflammatory or otherwise objectionable.
</p>
<p>
    ● Promote sexually explicit or pornographic material, violence, or 
    discrimination based on race, sex, religion, nationality, disability, 
    sexual orientation or age.
</p>
<p>
    ● Infringe any patent, trademark, trade secret, copyright or other intellectual 
    property or other rights of any other person.
</p>
<p>
    ● Violate the legal rights (including the rights of publicity and privacy) of 
    others or contain any material that could give rise to any civil or criminal 
    liability under applicable laws or regulations or that otherwise may be in conflict 
    with our Terms of Use, our Privacy Policy and this Policy.
</p>
<p>
    ● Promote any illegal activity, or advocate, promote or assist any unlawful act.
</p>
<p>
    ● Impersonate any person, or misrepresent your identity or affiliation with any 
    person or organization.
</p>
<p>
    ● Involve commercial activities or sales, such as contests, sweepstakes and 
    other sales promotions, barter or advertising.
</p>
<p>
    ● Give the impression that they emanate from or are endorsed by the UA, Understanding Ag, 
    LLC, or any other person or entity, if this is not the case.
</p>
<h3>
    <a name="_jpih6gvvtjin"></a>
    <strong>Honor Code</strong>
</h3>
<p>
    By participating in a Course, you agree that:
</p>
<p>
    ● The Course is being provided to you on an individual basis, and while individual participants 
    may discuss the Content (e.g., on a forum provided by UA account with other users. Participants 
    agree they will not copy or rebroadcast the Content.
</p>
<h3>
    <a name="_nwnt7uzhs665"></a>
    <strong>Changes to the Acceptable Use Policy</strong>
</h3>
<p>
    We may make changes to this Policy from time to time. We will notify you of such changes by posting 
    the modified version on our Website and indicating the date it was last modified. The date this 
    Policy was last modified is at the top of this page. Please periodically review this Policy so 
    that you are familiar with the current Policy and aware of any changes.
</p>
       </div>
    );
};


export default AcceptableUse;